import {userCanCreateAssetProjects} from '@netx/core-asset-project/enablers';
import {type ISavedCart} from '../schema';
import {savedCartIsNotEmpty} from './savedCartIsNotEmpty';

export const canReviewSavedCart = (savedCart?: ISavedCart) =>
	savedCartIsNotEmpty(savedCart) && userCanCreateAssetProjects();

export default canReviewSavedCart;
